import { Font } from "@react-pdf/renderer";
import notoSansRegular from "../../../assets/fonts/NotoSans/NotoSans-Regular.ttf";
import notoSansBold from "../../../assets/fonts/NotoSans/NotoSans-Bold.ttf";

export const HOTEL_PDF_FONT_FAMILY = "NotoSansHotel";

Font.register({
  family: HOTEL_PDF_FONT_FAMILY,
  fonts: [
    { src: notoSansRegular, fontWeight: 400 },
    { src: notoSansBold, fontWeight: 700 },
  ],
});
